import axios from "axios";
import showNotification from "./show_notification";


const clearLocalStorage = () => {

  // showLogoutAlert()
  setTimeout(()=>{
    localStorage.clear()
    window.location.replace('/login')
  },5000)

}

// Submit Form
const postSubmitForm = (url, data) => {
  const token = localStorage.getItem("userToken");
  const config = {
    headers: { Authorization: token },
  };
  return axios
    .post(url, data, config)
    .then((response) => {
      if (response.status >= 200 || response.status <= 299)
        return response.data;
      throw response.data;
    })
    .catch((err) => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            clearLocalStorage()
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};
export { postSubmitForm };

// Submit Form Without Auth
const postSubmitFormNoAuth = (url, data) => {
  return axios
    .post(url, data)
    .then((response) => {
      if (response.status >= 200 || response.status <= 299)
        return response.data;
      throw response.data;
    })
    .catch((err) => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};
export { postSubmitFormNoAuth };

// Submit Form with form-data
const postSubmitForm_withformdata = (url, data) => {
  const token = localStorage.getItem("userToken");
  const config = {
    headers: { Authorization: token },
  };
  return axios
    .post(url, data, config)
    .then((response) => {
      if (response.status >= 200 || response.status <= 299)
        return response.data;
      throw response.data;
    })
    .catch((err) => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 400:
            showNotification(err.response.data.message,"error")
            message =err.response.data.message
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};
export { postSubmitForm_withformdata };
